"use client";

// import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
// import { GoBell } from "react-icons/go";
import { BsQuestionCircle, BsGithub, BsBook, BsDiscord } from "react-icons/bs";
import { Separator } from "@/components/ui/separator";
import { BreadcrumbLinks } from "./BreadcrumbLinks";
import { usePathname } from "next/navigation";
import { ProjectSelector } from "./project-selector";
import { OrgSelector } from "./org-selector";

export const Header = () => {
  const pathname = usePathname();

  return (
    <div>
      <div className="flex w-full items-center justify-between px-4 py-3">
        <div className="flex items-center gap-4">
          {/* Organization, Project Selectors and Breadcrumbs */}
          <div className="flex items-center gap-2">
            <div className="w-44">
              <OrgSelector />
            </div>
            <span className="text-muted-foreground">/</span>
            <div className="w-44">
              <ProjectSelector />
            </div>
            <span className="text-muted-foreground">/</span>
            <BreadcrumbLinks pathname={pathname} />
          </div>
        </div>

       
      </div>
      <Separator />
    </div>
  );
};
